/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CustomerProfileResponseDto = {
    /**
     * Customer ID
     */
    id: number;
    /**
     * Customer full name
     */
    customerName: string;
    /**
     * Customer email
     */
    customerEmail?: string;
    /**
     * Customer phone
     */
    customerPhone?: string;
    /**
     * Customer address
     */
    customerAddress?: string | null;
    /**
     * Date of birth
     */
    dateOfBirth?: string;
    /**
     * Gender
     */
    gender?: CustomerProfileResponseDto.gender;
    /**
     * Total purchases amount
     */
    totalPurchases: number;
    /**
     * Number of purchases made
     */
    purchaseCount: number;
    /**
     * Loyalty points
     */
    loyaltyPoints: number;
    /**
     * Loyalty tier
     */
    loyaltyTier: CustomerProfileResponseDto.loyaltyTier;
    /**
     * Preferred payment method
     */
    preferredPaymentMethod?: string;
    /**
     * Customer notes
     */
    customerNotes?: string;
    /**
     * Marketing consent
     */
    marketingConsent: boolean;
    /**
     * Referral source
     */
    referralSource?: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
};
export namespace CustomerProfileResponseDto {
    /**
     * Gender
     */
    export enum gender {
        MALE = 'MALE',
        FEMALE = 'FEMALE',
        OTHER = 'OTHER',
    }
    /**
     * Loyalty tier
     */
    export enum loyaltyTier {
        BRONZE = 'BRONZE',
        SILVER = 'SILVER',
        GOLD = 'GOLD',
        PLATINUM = 'PLATINUM',
    }
}

